
<div class="p-grid spacing-demo">
	<div class="p-col-12">
		<div class="card">
			<h4>Spacing</h4>
			<p><a [routerLink]="['/utilities/grid']">PrimeFlex</a> provides various spacing utilities to modify
				an element's layout.</p>

			<h5>Classes</h5>
			<p>The spacing classes use the <i>p-&#123;property&#125;&#123;position&#125;-&#123;value&#125;</i> syntax whereas for responsive
				values <i>p-&#123;property&#125;&#123;position&#125;-&#123;breakpoint&#125;-&#123;value&#125;</i> format is used.</p>

			<h5>Property</h5>
			<p>Property can either be a margin or a padding.</p>
			<ul>
				<li><b>m</b>: margin</li>
				<li><b>p</b>: padding</li>
			</ul>

			<h5>Position</h5>
			<p>Position are available for the individual sides, the x-y axis or blank for the shortand of all sides.</p>
			<ul>
				<li><b>t</b>: top</li>
				<li><b>b</b>: bottom</li>
				<li><b>l</b>: left</li>
				<li><b>r</b>: right</li>
				<li><b>x</b>: left and right</li>
				<li><b>y</b>: top and bottom</li>
				<li><b>blank</b>: all sides</li>
			</ul>

			<h5>Value</h5>
			<p>Value field varies from 0 to 6 where default value of the <i>$spacer</i> is 1rem. The special <i>auto</i> value is available to margins only and used to center elements.</p>
			<ul>
				<li><b>0</b>: $spacer * 0</li>
				<li><b>1</b>: $spacer * .25</li>
				<li><b>2</b>: $spacer * .5</li>
				<li><b>3</b>: $spacer * 1</li>
				<li><b>4</b>: $spacer * 1.5</li>
				<li><b>5</b>: $spacer * 2</li>
				<li><b>6</b>: $spacer * 3</li>
				<li><b>auto</b>: auto margin</li>
			</ul>

			<h5>Breakpoint</h5>
			<p>Breakpoints define how the spacing should be defined depending on the screen size. Design is mobile first so smaller values
				can also apply to larger values e.g. md also applies to lg or xl if they are not explicitly defined.</p>
			<ul>
				<li><b>sm</b>: small screens e.g. phones</li>
				<li><b>md</b>: medium screens e.g. tablets</li>
				<li><b>lg</b>: large screens e.g. notebooks</li>
				<li><b>xl</b>: larger screens .e.g monitors</li>
			</ul>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="card">
			<h5>Use Case 1</h5>
			<p>Spacing is a handy utility when elements wrap when screen size get smaller. In example below, when buttons wrap
				they are displayed on top of each other whereas with spacing this issue can easily be resolved.
			</p>

			<h6>Without Spacing</h6>
			<button pButton type="button" label="Button 1" style="width:250px" ></button>
			<button pButton type="button" label="Button 2" style="width:250px" ></button>

			<h6>With Spacing</h6>
			<button pButton type="button" label="Button 1" style="width:250px" class="p-mr-2 p-mb-2" ></button>
			<button pButton type="button" label="Button 2" style="width:250px" class="p-mr-2"></button>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="card">
			<h5>Use Case 2</h5>
			<p>Spacing utilities also work seamlessly with responsive PrimeFlex grid utilty. Example below demonstrates a case where on a smaller screen inputs receive a margin to position themselves
				separately in stacked mode, reduce the dimension of the window to view the difference.
			</p>

			<h6>Without Spacing</h6>
			<div class="p-grid p-formgrid p-fluid">
				<div class="p-col-12 p-lg-4">
					<input pInputText />
				</div>
				<div class="p-col-12 p-lg-4">
					<input pInputText />
				</div>
				<div class="p-col-12 p-lg-4">
					<input pInputText />
				</div>
			</div>

			<h6>With Spacing</h6>
			<div class="p-grid p-formgrid p-fluid">
				<div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0">
					<input pInputText />
				</div>
				<div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0">
					<input pInputText />
				</div>
				<div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0">
					<input pInputText />
				</div>
			</div>
		</div>
	</div>
</div>
